import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function StartSavingPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-md'}`}>
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2024/11/Group-1000005662-1024x974.png" 
                alt="Seaside Vouchers" 
                className="h-16 w-16"
              />
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/e0d98287e8c9dc8abdecc58291257ecc.png" 
                alt="SEASIDE VOUCHERS" 
                className="h-12"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Home</Link>
              <Link to="/how-it-works" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">How it works</Link>
              <Link to="/seaside-offers" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Seaside Vouchers App</Link>
              <Link to="/leisure-home-sales" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Leisure Home Sales</Link>
              <Link to="/accommodation" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Accommodation</Link>
              <Link to="/contact" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Contact us</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-400 to-blue-500 overflow-hidden">
        {/* Animated Decorative Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-64 h-64 bg-yellow-300 rounded-full opacity-20 blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-80 h-80 bg-cyan-300 rounded-full opacity-20 blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-1/2 left-1/3 w-48 h-48 bg-white rounded-full opacity-10 blur-2xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center text-white mb-12">
            <h1 className="text-5xl font-bold mb-4 drop-shadow-lg">Start Saving Today</h1>
            <p className="text-xl max-w-3xl mx-auto drop-shadow-md">Download the Seaside Vouchers app and unlock exclusive deals</p>
          </div>
        </div>
      </section>

      {/* App Showcase */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Your Seaside Savings Start Here</h2>
              
              <div className="space-y-6 mb-8">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg">
                    <i className="ri-smartphone-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Location Enabled</h4>
                    <p className="text-sm text-gray-600">Our app is location enabled so you will always see the best offers local to you</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg">
                    <i className="ri-download-cloud-line text-2xl text-orange-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Available Now</h4>
                    <p className="text-sm text-gray-600">Available to download now on the App Store and Google Play Store</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg">
                    <i className="ri-notification-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Stay Updated</h4>
                    <p className="text-sm text-gray-600">Receive the latest offers straight to your phone with in-app notifications</p>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <a href="https://apps.apple.com/pk/app/seaside-vouchers-user/id6745555629" target="_blank" rel="noopener noreferrer" className="block cursor-pointer">
                  <img 
                    src="https://seasidevouchers.co.uk/wp-content/uploads/2025/10/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.png" 
                    alt="Download on App Store" 
                    className="h-14"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'block';
                      target.style.minHeight = '56px';
                    }}
                  />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.jeuxdevelopers.SeasideUser&pcampaignid=web_share&pli=1" target="_blank" rel="noopener noreferrer" className="block cursor-pointer">
                  <img 
                    src="https://seasidevouchers.co.uk/wp-content/uploads/2025/10/GetItOnGooglePlay_Badge_Web_color_English.png" 
                    alt="Get it on Google Play" 
                    className="h-14"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'block';
                      target.style.minHeight = '56px';
                    }}
                  />
                </a>
              </div>
            </div>

            <div className="flex justify-center">
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2024/12/002-1-1-e1734327161252.png" 
                alt="App Preview" 
                className="max-w-md w-full drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* App Screenshots */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">See The App In Action</h2>
          <p className="text-center text-gray-600 mb-12">
            Browse offers, save favorites, and redeem vouchers with ease
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="bg-white rounded-2xl shadow-xl p-4 mb-4">
                <img 
                  src="https://seasidevouchers.co.uk/wp-content/uploads/2024/12/awdasdzv.png" 
                  alt="App Screenshot 1" 
                  className="w-full rounded-lg"
                />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Browse Offers</h3>
              <p className="text-sm text-gray-600">Discover hundreds of deals near you</p>
            </div>

            <div className="text-center">
              <div className="bg-white rounded-2xl shadow-xl p-4 mb-4">
                <img 
                  src="https://seasidevouchers.co.uk/wp-content/uploads/2024/12/rtzeuj.png" 
                  alt="App Screenshot 2" 
                  className="w-full rounded-lg"
                />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">View Details</h3>
              <p className="text-sm text-gray-600">See full offer information and terms</p>
            </div>

            <div className="text-center">
              <div className="bg-white rounded-2xl shadow-xl p-4 mb-4">
                <img 
                  src="https://seasidevouchers.co.uk/wp-content/uploads/2024/12/002-1-1-e1734327161252.png" 
                  alt="App Screenshot 3" 
                  className="w-full rounded-lg"
                />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Redeem Vouchers</h3>
              <p className="text-sm text-gray-600">Show your voucher and start saving</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">Why Download Seaside Vouchers?</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6">
              <div className="w-14 h-14 flex items-center justify-center bg-orange-500 rounded-full mb-4">
                <i className="ri-money-pound-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Save Money</h3>
              <p className="text-sm text-gray-700">
                Get exclusive discounts on attractions, dining, shopping and entertainment
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-xl p-6">
              <div className="w-14 h-14 flex items-center justify-center bg-cyan-500 rounded-full mb-4">
                <i className="ri-gift-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Free Forever</h3>
              <p className="text-sm text-gray-700">
                No subscription fees, no hidden costs. Download and use completely free
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6">
              <div className="w-14 h-14 flex items-center justify-center bg-green-500 rounded-full mb-4">
                <i className="ri-refresh-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Unlimited Use</h3>
              <p className="text-sm text-gray-700">
                Use vouchers as many times as you want throughout your holiday
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6">
              <div className="w-14 h-14 flex items-center justify-center bg-purple-500 rounded-full mb-4">
                <i className="ri-map-pin-user-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Local Offers</h3>
              <p className="text-sm text-gray-700">
                Location-based offers show you the best deals wherever you are
              </p>
            </div>

            <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-xl p-6">
              <div className="w-14 h-14 flex items-center justify-center bg-pink-500 rounded-full mb-4">
                <i className="ri-user-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Family Friendly</h3>
              <p className="text-sm text-gray-700">
                Perfect for families - everyone can download and use the app
              </p>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-xl p-6">
              <div className="w-14 h-14 flex items-center justify-center bg-yellow-500 rounded-full mb-4">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Always Updated</h3>
              <p className="text-sm text-gray-700">
                New offers added regularly - get notified about the latest deals
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gradient-to-br from-cyan-500 to-cyan-600">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center text-white">
            <div>
              <div className="text-5xl font-bold mb-2">100+</div>
              <div className="text-lg">Active Offers</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">50+</div>
              <div className="text-lg">Partner Businesses</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">£1000s</div>
              <div className="text-lg">Saved by Users</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">100%</div>
              <div className="text-lg">Free to Use</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-orange-500">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Start Saving?</h2>
          <p className="text-xl text-white mb-8">Download the app now and enjoy exclusive seaside offers</p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a href="https://apps.apple.com/pk/app/seaside-vouchers-user/id6745555629" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2025/10/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.png" 
                alt="Download on App Store" 
                className="h-14"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'block';
                  target.style.minHeight = '56px';
                }}
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.jeuxdevelopers.SeasideUser&pcampaignid=web_share&pli=1" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2025/10/GetItOnGooglePlay_Badge_Web_color_English.png" 
                alt="Get it on Google Play" 
                className="h-14"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'block';
                  target.style.minHeight = '56px';
                }}
              />
            </a>
          </div>

          <p className="text-white text-sm">
            Available on iOS and Android • Free Download • No Subscription Required
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-cyan-500 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2024/11/Group-1000005662-1024x974.png" 
                alt="Seaside Vouchers" 
                className="h-20 w-20 transform hover:scale-110 transition-transform duration-300"
              />
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/e0d98287e8c9dc8abdecc58291257ecc.png" 
                alt="SEASIDE VOUCHERS" 
                className="h-10"
              />
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Quick Link</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Home</Link></li>
                <li><Link to="/how-it-works" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">How it works</Link></li>
                <li><Link to="/seaside-offers" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Seaside offers</Link></li>
                <li><Link to="/voucher-book" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Voucher Book</Link></li>
                <li><Link to="/leisure-home-sales" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Leisure Home Sales</Link></li>
                <li><Link to="/accommodation" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Accommodation</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="https://seasidevouchers.co.uk/privacy-policy/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Privacy &amp; cookie policy</a></li>
                <li><a href="https://seasidevouchers.co.uk/terms-conditions/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">T&amp;C</a></li>
                <li><Link to="/contact" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Contact us</Link></li>
                <li><Link to="/business-registration" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Add Your Business</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Follow Us</h4>
              <div className="flex gap-4">
                <a href="https://www.facebook.com/people/seasidevouchers/61566031950810/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://www.instagram.com/seaside_vouchers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="https://www.tiktok.com/@seasidevouchers" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-tiktok-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-6 text-center text-sm">
            <p>Copyright © 2023 Seaside Voucher, All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
